import script from "./Languages.vue?vue&type=script&setup=true&lang=js"
export * from "./Languages.vue?vue&type=script&setup=true&lang=js"

import "./Languages.vue?vue&type=style&index=0&id=9dd9cca0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\dashboard-pro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dd9cca0"]])

export default __exports__